import { render, staticRenderFns } from "./HoverMenu.vue?vue&type=template&id=0f008cfb&scoped=true"
import script from "./HoverMenu.vue?vue&type=script&lang=js"
export * from "./HoverMenu.vue?vue&type=script&lang=js"
import style0 from "./HoverMenu.vue?vue&type=style&index=0&id=0f008cfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f008cfb",
  null
  
)

export default component.exports